// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Diamond48Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Diamond48: FC<Diamond48Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="48"
            height="48"
        >
            <path d="M24.1 43 6.15 25.35l9.85-12h16.15l9.9 12L24.1 43ZM8.65 11.95l-3.6-3.5 2.15-2.2 3.55 3.6-2.1 2.1Zm13.95-3.9V3h3v5.05h-3Zm16.8 3.9-2.1-2.1 3.6-3.6 2.1 2.2-3.6 3.5ZM24.1 38.8l12.3-12.1H11.8l12.3 12.1Zm-6.65-22.45L11.4 23.7h25.4l-6.05-7.35h-13.3Z" />
        </svg>
    );
};

export default Diamond48;
